<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="about">
        <div class="about-left">

          <ul>
            <li class="abouttype" :class="{ blue: selectedId === item.id }" v-for="item in aboutItems" :key="item.index" @click="authority(item.isJoin,item.id)"><img class="aboutpicture" :src="imgUrl + item.pic">
              <span class="numcare" v-for="itema in nums" :key="itema.id" v-if="item.isJoin && itema.use && itema.id == item.id && !send">{{ itema.use> 99 ? '99' : itema.use}}</span>
              <span>{{item.name}}</span>

            </li>
            <!--      
            <li class="abouttype"><img class="aboutpicture" src="../assets/images/aboutpicture.jpg">跨境电商交流圈</li>

            <li class="abouttype"><img class="aboutpicture" src="../assets/images/aboutpicture.jpg">孕婴童行业交流圈</li>

            <li class="abouttype"><img class="aboutpicture" src="../assets/images/aboutpicture.jpg">众筹投资交流圈</li>

            <li class="abouttype"><img class="aboutpicture" src="../assets/images/aboutpicture.jpg">国际贸易交流圈</li> -->

          </ul>

        </div>
        <div class="about-right">

          <div class="marquees">
            <router-link to="/notice">
              <div class="marquee">
                <img class="horn" src="../assets/images/loud.png">
                <div class="marqueemove">
                  <div class="text">{{noticetitle}}</div>
                </div>
                <div class="more">更多>></div>
              </div>
            </router-link>

          </div>

          <div class="header">
            <div> <span>行业</span>
              <el-select v-model="industry" class="select_industry" @change="changeindustryId" clearable>
                <el-option v-for="item in selectList1" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div><span>大区</span>
              <el-select v-model="region" class="select_region" @change="changeregionId" clearable>
                <el-option v-for="item in selectList2" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="findpart">
              <el-popover placement="bottom" popper-class="down-popover" ref="querySearch" trigger="click"><template v-if="searchResults&&searchResults.length">
                  <span class="mycollect" @click="mycollect">我的关注</span>
                  <div v-for="item in searchResults" :key="item.id" class="option-item">
                    <div @click="jumpchatRecord(item.name)" class="searchhistory">
                      <el-tag type="info">{{item.name}}</el-tag>
                    </div>
                    <i class="el-icon-close" @click="deleteItem(item.id)" />
                  </div>
                </template>
                <template v-else>
                  <span class="mycollectno" @click="mycollect">我的关注</span>
                  <div class="nosearch">暂无搜索记录</div>
                </template>
                <el-input slot="reference" @keyup.enter.native="addsearch()" class="find" placeholder="关键词查询" v-model="searchvalue" @input="reset()" maxlength="50" @clear="getchatRecord" clearable>
                  <i slot="prefix"><img class="findimg" src="../assets/images/find.png" /></i>
                </el-input>
              </el-popover>
              <el-button type="primary" class="search" @click="addsearch()">查询</el-button>

            </div>

          </div>
          <!-- <el-menu v-if="(findVisible)" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">最近搜索</el-menu-item>

            <el-menu-item index="2">我的关注</el-menu-item>

          </el-menu> -->

          <div class="content" ref="scrollDiv" @scroll="handleScroll($event)">
            <div class="chatcontent" v-for="(item, i) in chatItems" :key="i">
              <div class="chat-user-1" v-if="!(item.appuserId == me)">

                <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}"> <img class="chat-user-1-headicon" :src="imgUrl + item.pic" v-if="item.pic" />
                  <img class="chat-user-1-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                <div class="flex">
                  <div class="chatname" v-if="item.content">{{item.mininame}}
                    <span class="time">{{item.createTime.substr(0,16)}}</span>
                  </div>
                  <div v-if="item.contentType === 0">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div class="chat-user-1-text" v-if="item.contentType === 1">
                    <span v-html="setKeyWord1(item.content)" :class="['image-container']"></span>
                  </div>
                  <div v-if="item.contentType === 2">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div v-if="item.contentType == 3">
                    <div class="chat-user-1-text" @click="openFile(imgUrl+item.content)">文件下载</div>
                  </div>
                </div>
              </div>
              <div class="chat-user-2" v-else>
                <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}"><img class="chat-user-2-headicon" :src="imgUrl + item.pic" v-if="item.pic" />
                  <img class="chat-user-2-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                <div v-if="item.contentType === 0">
                  <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                </div>
                <div class="chat-user-2-text" v-if="item.contentType === 1">
                  <span v-html="setKeyWord2(item.content)" :class="['image-container']"></span>
                </div>
                <div v-if="item.contentType === 2">
                  <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>
                </div>
                <div v-if="item.contentType == 3">
                  <div class="chat-user-2-text" @click="openFile(imgUrl+item.content)">文件下载</div>
                </div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="emopackage">
              <img class="emoimg" v-for="(item, i) in emoItems" :key="i" :src="imgUrl + item.icon" @click="sendimg(item.icon)" />
            </div>
            <div class="dialog_icon_total">
              <div>
                <img class="dialog_icon" @click="showexpression" src="../assets//images/expression.png" />
              </div>

              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile1" :on-success="updatepicture1" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif">
                <div>
                  <img class="dialog_icon" src="../assets//images/photo.png" />
                </div>
              </el-upload>
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile2" :on-success="updatepicture2" accept=".zip,.doc,.docx,.xlsx,.xls,.txt,.ppt,.pptx,.pdf">
                <img class="dialog_icon" src="../assets/images/file.png" />
              </el-upload>

              <!-- <el-input class="textarea_submit"
                  v-model="textarea"
                  @input="onInput"
                  @keydown.native="handleKeyCode($event)"
                /> -->
            </div>

            <!-- <el-input class="textarea_submit" type="textarea" :rows="2" placeholder="请输入文字" v-model="textarea" @keydown.native="handleKeyCode($event)">
            </el-input> -->
            <!-- <picker :include="['people','Smileys']" :showSearch="false" :showPreview="false" :showCategories="false" @select="addEmoji" v-if="showpick" /> -->
            <quill-editor class="ql-editor" v-model="textarea" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)" @keydown.native="handleKeyCode($event)" id="editor">
            </quill-editor>

            <el-button type="primary" class="submit" @click="sendmessage()" round>发送 </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogFormVisible">
      <!-- <div class="multchoice">选择本属性行业</div>
      <el-checkbox-group v-model="check1" >

        <el-checkbox v-for="item in checkList1" :key="item.id" :label="item.name"></el-checkbox>
      </el-checkbox-group>
      <div class="multchoice">选择本属性大区</div>
      <el-checkbox-group v-model="check2" >

        <el-checkbox v-for="item in checkList2" :key="item.id" :label="item.name"></el-checkbox>
      </el-checkbox-group> -->
      <div class="block">
        <div class="h3">选择本属性行业</div>
        <div class="pro-list">
          <div class="pro-item" :class="item.checked ? 'active' : ''" v-for="item,index in checkList1" :key="item.id" @click="chooseHangye(item.id,index)">{{item.name}}</div>
        </div>
      </div>
      <div class="block">
        <div class="h3">选择本属性大区</div>
        <div class="pro-list">
          <div class="pro-item" :class="item.checked ? 'active' : ''" v-for="item,index in checkList2" :key="item.id" @click="chooseDaqu(item.id,index)">{{item.name}}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false;cancel()">取 消</el-button>
        <el-button type="primary" @click="ok()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import transparentheaders from "../components/transparentheaders.vue";
import {
  Picker
} from "emoji-mart-vue"; //引入组件
import Quill from 'quill';
import {
  chatRecordPropertycount,
  getLatestOne,
  home,
  token,
  getpropertylist,
  industryList,
  regionList,
  joinProperty,
  listSearchHistory,
  deleteSearchHistory,
  addSearchHistory,
  chatRecordlist,
  emojisList,
  addchat,
  listMyCollect
} from "../api/api";
import {
  Thumbs
} from "swiper";
const aboutItems = [];
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
const chatimgItems = [];
const emoItems = [];
const chatItems = [];
const searchResults = []

export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
    ellipsisnote(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    }
  },
  components: {
    transparentheaders,
    Picker
  },
  data() {
    return {
      msg: "",
      activeNames: ['1'],
      id: "", //圈子
      join: "", //圈子限制
      textarea: "",
      searchvalue: "",
      emoItems, //存放表情包
      chatimgItems, //存放发送消息的表情
      aboutItems: aboutItems,
      chatItems,
      userid: "",
      activeIndex: '1',
      findvalue: false, //是否开启搜索
      region: "",
      industry: "",
      searchHistory: [], //存放搜索历史
      searchResults,
      checkList1: [], //多选框
      checkList2: [], //多选框
      selectList1: [], //多选下拉框
      selectList2: [],
      options: [],
      nums: [],
      dialogFormVisible: false,
      noticetitle: "", //通知标题
      imgUrl,
      propertyId: "",
      regionId: "",
      industryId: "",
      industryList: [], //行业
      regionList: [], //大区
      multipartFile1: {
        biz: "kefu"
      }, //文件上传参数
      multipartFile2: {
        biz: "file",
        'content-type': 'multipart/form-data'

      }, //文件上传参数
      startid: "",
      sum: 0,
      selectedId: "",
      aboutsum: "",
      editorOption: {
        modules: {
          toolbar: [

          ],
          keyboard: {
            bindings: {
              // 阻止回车键输入 br 标签
              noBreak: {
                key: 13,
                handler: function (e) {
                  return false;
                }
              }
            }
          }
        },
        placeholder: '请输入文字',
      },
      pageNo: 1,
      arr: [],
      loading: true,
      send: false,
      currenttime: "", //当前时间
      collect: false, //判断是否是关注状态
      websocket: null,
      heartbeatTimer: null, // 心跳定时器
      isReconnect: true, //判断是否需要自动重连
    };
  },
  computed: {
    me() {
      return JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
  },
  created() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id

    this.getlistitems();
    this.selectedId = JSON.parse(sessionStorage.getItem("indexTime"))[0].id
  },
  mounted() {

    getLatestOne().then(res => {
      if (res.data.code == 200) {
        this.noticetitle = res.data.result.title
      }
    });
    token().then(res => {
      if (res.data.code == 200) {

      }
    });
    home().then(res => {
      if (res.data.code == 200) {

      }
    });
    this.openTimer()
    // setTimeout(() => {
    //   var button = document.querySelectorAll(".abouttype");
    //   button[0].style.color = "blue";
    //   this.changecolor();
    // }, 500)

    this.init();

    this.createWebSocket();
      window.onbeforeunload = function () {
        this.websocket.close();
      }

  },
  destroyed() {
    window.removeEventListener('beforeunload', this.cleanUp);
  },
  methods: {
    createWebSocket() {
      var userId = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
      if ('WebSocket' in window) {
        // websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
        // this.websocket = new WebSocket("ws://q66uqq.natappfree.cc/jeecg-boot/websocketGroup/" + userId);
        this.websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketGroup/" + userId);
      } else {
        alert('当前浏览器 Not support websocket')
      }
      let self = this
      //连接发生错误的回调方法
      this.websocket.onerror = function () {
        console.log("WebSocket连接发生错误");
      };
      let isConnected = false;
      //连接发生错误的回调方法

      //连接成功建立的回调方法
      if (!isConnected) {
        this.websocket.onopen = function connectWebSocket() {
          console.log("WebSocket连接成功");
          isConnected = true;
          self.heartbeatTimer = setInterval(function () {
            self.websocket.send("heartbeat");
          }, 30 * 1000);
        }

        this.websocket.onclose = function (e) {
          console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
          // 停止心跳定时器
          self.createWebSocket();
          //    clearInterval(this.heartbeatTimer);

          //   // 断线后自动重连
          //   if (this.isReconnect) {
          //     setTimeout(function () {
          //       console.log("WebSocket 尝试重新连接");
          //       this.createWebSocket();
          //     }, 3 * 1000);
          //   }
        }
      }
      //接收到消息的回调方法
      this.websocket.onmessage = (event) => {

        const data = JSON.parse(event.data);
        data.mininame = data.username 
        data.pic = data.userPic 
        if(data.propertyId == this.propertyId)
        this.chatItems.push(data);
  
        this.handleScrollBottom()

        // this.navItems[2].isred = false;
        this.$store.commit('updateGlobalVariable', 1);

        //  this.playAudio()
        let buttonAudio = document.getElementById('my_audio');
        var audio = require('../assets/audios/y1479.mp3')
        buttonAudio.setAttribute('src', audio)
        buttonAudio.play()

      }
    
      window.addEventListener('beforeunload', this.cleanUp);
    },

    cleanUp() {
      if (this.websocket !== null && this.websocket.readyState === 1) {
        this.websocket.close();
      }
    },
    addEmoji(e) {
      console.log(e.native)
      console.log(typeof e.native)
      this.textarea += e.native;

    },
    beforeDestroy() { //页面关闭时清除定时器  
      this.cleanUp();
      if (this.timer)
        clearInterval(this.timer);
    },
    updatepicture1(res) {
      let data = {
        appuserId: this.userid,
        content: res.message,
        contentType: 2,
        propertyId: this.id,
      }
      console.log("111")
      addchat(data).then(res => {
        if (res.data.code == 200) {
          // this.getchatRecord();
        } else {
          this.msg = res.data.message;
          this.open();
        }
      });
      data.createTime = this.currentTime()
       data.pic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
      this.chatItems.push(data);
      this.handleScrollBottom()
    },
    updatepicture2(res) {
      let data = {
        appuserId: this.userid,
        content: res.message,
        contentType: 3,
        propertyId: this.id,
      }
      addchat(data).then(res => {
        if (res.data.code == 200) {
          // this.getchatRecord();
        } else {
          this.msg = res.data.message;
          this.open();
        }
      });
      data.createTime = this.currentTime()
       data.pic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
      this.chatItems.push(data);
      this.handleScrollBottom()
    },
    onEditorChange({
      quill,
      html,
      text
    }) {
      console.log("内容改变事件", quill, html, text);
      quill.on('text-change', function (delta, oldDelta, source) {
        if (source == 'user') {
          console.log(quill.root.innerHTML);
          this.textarea = quill.root.innerHTML;
        }
      }.bind(this));
      this.textarea = html;
    },

    goBack() {
      this.findVisible = false;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    // changefindVisible() {
    //   this.findVisible = true;
    //   console.log(this.findVisible)
    // },
    sendmessage() {
      this.send = true;
      console.log(this.textarea)
      if (this.textarea && !(this.textarea.trim() === "")) {

        let data = {
          appuserId: this.userid,
          content: this.textarea.match(/\<img.*?\>/) ? this.textarea : this.textarea.replace(/ /g, '&nbsp;'),
          contentType: 1,
          propertyId: this.id,
        }
        addchat(data).then(res => {
          if (res.data.code == 200) {
            this.pageNo = 1
            // this.getchatRecord();
            this.textarea = ""
          } else {
            this.msg = res.data.message;
            this.open();
          }

        });
        var userId = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
        data.createTime = this.currentTime()
        data.pic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
        this.chatItems.push(data);
        this.handleScrollBottom()
      } else {
        this.msg = "发送内容不能为空"
        this.open()
      }

    },

    handleScrollBottom() {
      console.log("handleScrollBottom")
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({
          top: scrollElem.scrollHeight,
          behavior: "smooth"
        });
      });
    },
    clear() {
      this.value = "";
    },
    cleargroup() {
      this.newgroup = "";
    },

    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        if (this.msg === "注册成功") {
          this.$router.push({
            path: "/"
          });
        }
      });
    },
    handleKeyCode(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        console.log(e)
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation(); //Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.sendmessage();
      }
      //      if (e.keyCode === 32) {  // 检查按下的键是否是空格键（keyCode为32）
      //   // e.preventDefault();  // 阻止输入框默认的空格输入行为

      //   const textareaContent = this.textarea;
      //   const convertedContent = textareaContent;

      //   this.textarea = convertedContent;
      // }
    },

    setKeyWord1(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");
        return str.replace(
          reg,
          `<span style="color: rgb(55,128,237);">${this.searchvalue}</span>`,

        );
      } else {
        return str;
      }
    },
    setKeyWord2(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");
        return str.replace(
          reg,
          `<span style="color: rgb(195,229,255);">${this.searchvalue}</span>`,

        );
      } else {
        return str;
      }
    },
    reset() {
      this.findvalue = false;
    },
  onEditorFocus(){

    },
    onEditorChange() {

    },
    clearTextarea() {
      this.textarea = "";
    },
    showexpression() {
      var emo = document.querySelector(".emopackage");

      if (this.showpick) {
        this.showpick = false;
      } else {
        this.showpick = true;
      }
      if ((emo.style.display === "block")) {
        emo.style.display = "none";
      } else {
        emo.style.display = "block";
      }

    },

    // selectabout() {

    //   var select = document.querySelectorAll(".abouttype");
    //   select[0].style.color = "blue";
    //   var button = document.querySelectorAll(".abouttype");
    //   for (let i = 0; i < button.length; i++) {
    //     button[i].onclick = function () {
    //       for (let j = 0; j < select.length; j++) {
    //         if (j === i) {
    //           select[j].style.color = "blue";
    //         } else {
    //           select[j].style.color = ""; // 设置为空字符串，恢复初始值
    //         }
    //       }
    //     }
    //   }
    // },

    // changecolor() {
    //   var button = document.querySelectorAll(".abouttype");
    //   var select = document.querySelectorAll(".abouttype");
    //   button[0].style.color = "blue";
    //   if (this.join === 1) {
    //     for (let i = 0; i < button.length; i++) {
    //       button[i].onclick = function () {

    //         for (let j = 0; j < select.length; j++) {
    //           if (j === i) {
    //             select[j].style.color = "blue";
    //           } else {
    //             select[j].style.color = ""; // 设置为空字符串，恢复初始值
    //           }
    //         }
    //       }
    //     }
    //   }

    // },
    init() {
      emojisList().then(res => {
        if (res.data.code == 200) {
          this.emoItems = res.data.result
        }
      });
      this.propertyId = JSON.parse(sessionStorage.getItem("indexTime"))[0].id
      industryList({
        propertyId:  this.propertyId,
      }).then(res => {
        this.selectList1 = res.data.result
      });
      regionList({
        propertyId:  this.propertyId,
      }).then(res => {
        this.selectList2 = res.data.result
      });
      this.loadAll();
      this.id = JSON.parse(sessionStorage.getItem("indexTime"))[0].id;
      this.currenttime = this.currentTime();
      this.getchatRecord();

    },
    authority(join, id) {
      this.industry = ""
      this.region = ""
      this.industryId = ""
      this.regionId = ""
      this.collect = true
      this.join = join
      if (this.join == 1) {
        this.id = id
        this.getlistitems_change();
        this.selectedId = id;
        console.log(this.id)
        this.propertyId = this.id
        industryList({
          propertyId: this.id
        }).then(res => {
          this.checkList1 = res.data.result;
          this.selectList1 = res.data.result

        });
        regionList({
          propertyId: this.id
        }).then(res => {
          this.checkList2 = res.data.result;
          this.selectList2 = res.data.result

        });
        this.getchatRecord();
        this.$forceUpdate();
      } else {
        this.propertyId = id
        industryList({
          propertyId: id
        }).then(res => {
          this.checkList1 = res.data.result;

        });
        regionList({
          propertyId: id
        }).then(res => {
          this.checkList2 = res.data.result;

        });
        this.openauthority();
      }
    },
    // querySearch(queryString, cb) {
    //   var searchHistory = JSON.parse(sessionStorage.getItem('searchHistory_about'));
    //   var results = queryString ? searchHistory.filter(this.createFilter(queryString)) : searchHistory;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return (searchHistory) => {
    //     return (searchHistory.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    loadAll() {
      listSearchHistory({
        userId: this.userid,
      }).then(res => {
        if (res.data.code == 200) {
          this.searchResults = res.data.result
          console.log(this.searchResults)
        }
      });
      // const noArr = [] // 历史记录数组
      // const value = this.searchvalue
      // noArr.push({
      //   value: value
      // })
      // if (JSON.parse(sessionStorage.getItem('searchHistory_about'))) {
      //   // 判断是否已有xxx查询记录的sessionStorage
      //   if (sessionStorage.getItem('searchHistory_about').indexOf(value) > -1) { // 判断是否已有此条查询记录，若已存在，则不需再存储
      //     return
      //   }
      //   if (JSON.parse(sessionStorage.getItem('searchHistory_about')).length >= 5) {
      //     const arr = JSON.parse(sessionStorage.getItem('searchHistory_about'))
      //     arr.pop()
      //     sessionStorage.setItem('searchHistory_about', JSON.stringify(arr))
      //   }
      //   sessionStorage.setItem('searchHistory_about', JSON.stringify(noArr.concat(JSON.parse(sessionStorage.getItem('searchHistory_about')))))
      // } else { // 首次创建
      //   sessionStorage.setItem('searchHistory_about', JSON.stringify(noArr))
      // }
      // this.searchResults = JSON.parse(sessionStorage.getItem('searchHistory_about'));

    },
    deleteItem(idd) {
      // this.options = JSON.parse(sessionStorage.getItem('searchHistory_about'))
      // this.options.splice(this.options.findIndex(item => item.value === val), 1)
      // sessionStorage.setItem('searchHistory_about', JSON.stringify(this.options))
      // this.searchResults = JSON.parse(sessionStorage.getItem('searchHistory_about'));

      deleteSearchHistory({
        id: idd
      }).then(res => {
        if (res.data.code == 200) {

          this.loadAll();
        }
      });
    },
    addsearch() {
      if (this.searchvalue && !(this.searchvalue.trim() === "")) {
        this.findvalue = true;
        let data = {
          appuserId: this.userid,
          name: this.searchvalue,
        };
        addSearchHistory(data).then(res => {
          if (res.data.code == 200) {
            this.loadAll();
          }
        });
        chatRecordlist({
          propertyId: this.propertyId ? this.propertyId : JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
          regionId: this.regionId,
          industryId: this.industryId,
          contentType: 1,
          keyword: this.searchvalue,
          pageNo: 1,
          pageSize: 40
        }).then(res => {
          if (res.data.code == 200) {
            this.chatItems = res.data.result.records.reverse()

          }
        });
      } else {
        this.msg = "查询内容不能为空";
        this.open();
      }
    },
    getlistitems() {
      let time = []
      getpropertylist({
        pageNo: 1,
        userId: this.userid,
      }).then(res => {
        this.aboutItems = res.data.result.records

        this.aboutItems.forEach((item, i) => {
          if (!sessionStorage.getItem("indexTime")) {
            time.push({
              id: item.id,
              time: this.currentTime(),
            })

          } else {
            time.push({
              id: item.id,
              time: JSON.parse(sessionStorage.getItem("indexTime"))[i].hasOwnProperty("time") ? JSON.parse(sessionStorage.getItem("indexTime"))[i].time : this.currentTime(),
            })
          }
        })
        sessionStorage.setItem("indexTime", JSON.stringify(time))

      });

      return true
    },
    getlistitems_change() {
      let time = []
      getpropertylist({
        pageNo: 1,
        userId: this.userid,
      }).then(res => {
        this.aboutItems = res.data.result.records

        res.data.result.records.forEach((item, i) => {
          if (!sessionStorage.getItem("indexTime")) {
            time.push({
              id: item.id,
              time: this.currentTime(),
            })

          } else {
            time.push({
              id: item.id,
              time: JSON.parse(sessionStorage.getItem("indexTime"))[i] = this.currentTime(),
            })
          }
        })
        sessionStorage.setItem("indexTime", JSON.stringify(time))

      });

      return true
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      return strDate;
    },
    openTimer() {
      const timer = setInterval(() => {
        this.getTime()

      }, 3000)
      this.getTime()

    },
    getTime() {
      let r = []
      //  chatRecordlist({
      //     propertyId: this.id,
      //     regionId: this.regionId,
      //     industryId: this.industryId,
      //     keyword: this.searchvalue,
      //     pageNo: 1,
      //     pageSize: 20
      //   }).then(res => {
      //     if (res.data.code == 200) {
      //       this.chatItems = res.data.result.records.reverse()
      //     }
      //   });
      this.aboutItems.forEach((item, i) => {
        chatRecordPropertycount({
          propertyId: JSON.parse(sessionStorage.getItem("indexTime"))[i].id,
          startQueryTime: JSON.parse(sessionStorage.getItem("indexTime"))[i].time,
        }).then(res => {
          if (res.data.code == 200) {

            r.push({
              id: item.id,
              use: res.data.result
            })
            this.nums = r
            // console.log(this.nums)
          }
        })
      })
      if (!this.nums.length) {
        return
      }
      // let arr = this.aboutItems((item, i) => {
      //   return {
      //     id: item.id,
      //     isJoin: item.isJoin,
      //     name: item.name,
      //     pic: item.pic,
      //     use: this.userNum(item.id)
      //   }
      // })
      // this.aboutItems = arr

      this.$forceUpdate()
    },
    userNum(id) {
      let a = this.nums.filter(item => {
        return item.id == id
      })
      return a[0].use
    },
    openauthority() {
      this.$confirm('您没有访问权限', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '申请访问',

        type: 'warning'
      }).then(() => {
        this.dialogFormVisible = true
      }).catch(() => {

      });
    },
    chooseHangye(id) {
      console.log(id)
      let index = this.checkList1.findIndex(item => item.id === id)
      let item = this.checkList1[index]
      if (!item.checked) {
        this.industryList.push({
          "industryId": id
        })
      } else {
        this.industryList.splice(index, 1)
      }
      item.checked = !item.checked
      this.checkList1 = this.checkList1
      this.industryList = this.industryList
      this.$forceUpdate()
    },
    chooseDaqu(id) {
      let index = this.checkList2.findIndex(item => item.id === id)
      let item = this.checkList2[index]
      if (!item.checked) {
        this.regionList.push({
          "bigRegionId": id
        })
      } else {
        this.regionList.splice(index, 1)
      }
      item.checked = !item.checked
      this.checkList2 = this.checkList2
      this.regionList = this.regionList
      this.$forceUpdate()
    },
    ok() {
      console.log(this.propertyId)
      if (this.industryList.length == 0) {
        this.msg = "请选择行业"
        this.open()
        return false
      }
      if (this.regionList.length == 0) {
        this.msg = "请选择大区"
        this.open()
        return false
      }

      if (this.industryList.length && this.regionList.length) {
        let data = {
          propertyApprove: {
            appuserId: this.userid,
            propertyId: this.propertyId,
          },
          regionList: this.regionList,
          industryList: this.industryList
        }

        joinProperty(data).then(res => {
          if (res.data.code == 200) {
            this.msg = "已提交申请，等待后台审核！";
            this.open()

          } else {
            this.msg = "申请成功，等待后台审核！";
            this.open()
          }
          this.dialogFormVisible = false
        })
      }
      this.cancel()
    },
    cancel() {

      this.checkList1 = []
      this.checkList2 = []

      this.industryList = []
      this.regionList = []
    },
    changeregionId(e) {
      this.regionId = e
      this.getchatRecord()
    },
    changeindustryId(e) {
      this.industryId = e
      this.getchatRecord()
    },
    handleScroll(e) {

      let el = e.target
      //判断是否到达div容器底部

      if (el.scrollTop <= 0) {
        //控制页数
        this.pageNo = this.pageNo + 1
        //调用后台接口
        this.getpage()

      }
    },
    getpage() {
      if (!this.collect) {
        chatRecordlist({
          propertyId: this.id,
          regionId: this.regionId,
          industryId: this.industryId,
          keyword: this.searchvalue,
          pageNo: this.pageNo,
          pageSize: 7
        }).then(res => {
          if (res.data.code == 200) {
            // this.chatItems.unshift(...res.data.result.records.reverse())
            this.chatItems = res.data.result.records.reverse().concat(this.chatItems)
            if (this.pageNo == 1) {
              this.handleScrollBottom()
            }

            this.pageNo = this.pageNo + 1
            console.log(this.pageNo)
          }
        });
      } else {
        listMyCollect({
          userId: this.userid,
          propertyId: this.id,
          regionId: this.regionId,
          industryId: this.industryId,
          keyword: this.searchvalue,
          pageNo: this.pageNo,
          pageSize: 7
        }).then(res => {
          if (res.data.code == 200) {
            // this.chatItems.unshift(...res.data.result.records.reverse())
            this.chatItems = res.data.result.records.reverse().concat(this.chatItems)
            if (this.pageNo == 1) {
              this.handleScrollBottom()
            }

            this.pageNo = this.pageNo + 1
            console.log(this.pageNo)
          }
        });
      }
    },
    getchatRecord() {

      const timer = setInterval(() => {
        // this.getnewchat()

      }, 1500)
      chatRecordlist({
        propertyId: this.id,
        regionId: this.regionId,
        industryId: this.industryId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 7
      }).then(res => {
        if (res.data.code == 200) {
          // const newChatItems = res.data.result.records.reverse();
          this.chatItems = res.data.result.records.reverse()
          // // 判断 chatItems 数组长度增加
          // if (newChatItems.length > this.chatItems.length) {
          //   this.chatItems = newChatItems;
          this.handleScrollBottom()
          // }
        }
      });

    },
    getnewchat() {
      chatRecordlist({
        propertyId: this.id,
        // regionId: this.regionId,
        // industryId: this.industryId,
        startQueryTime: this.currenttime,
        // keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.result.records.length) {
            this.chatItems = this.chatItems.concat(res.data.result.records)
            this.currenttime = this.currentTime()
            this.handleScrollBottom()
          }
        }
      });
    },
    jumpchatRecord(e) {
      this.searchvalue = e;
      this.findvalue = true;
      chatRecordlist({
        propertyId: this.propertyId ? this.propertyId : JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
        regionId: this.regionId,
        industryId: this.industryId,
        contentType: 1,
        keyword: e,
        pageNo: 1,
        pageSize: 40
      }).then(res => {
        if (res.data.code == 200) {
          this.chatItems = res.data.result.records.reverse()
          // for (var i = 0; i < this.chatItems.length; i++) {
          //   var item = this.chatItems[i];

          //   if (item.content) {
          //     const regex = /(<([^>]+)>)/gi;
          //     item.content = item.content.replace(regex, '');
          //     if(item.content.includes(e)) {

          //     }
          //     else {
          //        this.chatItems.splice(i, 1);
          //        i--
          //     }
          //   }
          // }
        }
      });
    },
    openFile(url) {
      window.open(url)
    },
    mycollect() {
      this.collect = true;
      listMyCollect({
        userId: this.userid,
        propertyId: this.id,
        regionId: this.regionId,
        industryId: this.industryId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 7
      }).then(res => {
        if (res.data.code == 200) {
          this.chatItems = res.data.result.records.reverse()

        }
      });
    },
    sendimg(e) {

      let data = {
        appuserId: this.userid,
        content: e,
        contentType: 0,
        propertyId: this.id,
      }
      var res

      res = imgUrl + e
      console.log(res)
      if (res) {
        // 获取光标所在位置
        let quill = this.$refs.myQuillEditor.quill;
        quill.focus()
        let length = quill.getSelection().index
        console.log(length)
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, "image", res);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败！");
      }
      // addchat(data).then(res => {
      //   if (res.data.code == 200) {
      //     this.getchatRecord();
      //   } else {
      //     this.msg = res.data.message;
      //     this.open();
      //   }
      // });
    },

  },

};
</script>

<style lang="scss" scoped>
.about {
  margin-top: 70px;
  display: flex;
}

.about-left {
  background: white;
  flex-grow: 0.23;
  margin-right: 10px;
  font-size: 26px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  flex-wrap: nowrap;
  padding: 30px 15px 15px 15px;
  flex: 0 0 320px;
  overflow: auto;
}

.aboutservice {
  width: 80px;
  height: 80px;
  position: fixed;
  cursor: pointer;
  right: 10%;
  top: 50%;
}

.el-collapese {
  padding: 20px;
}

>>>.collapse-title {
  flex: 1 0 90%;
  order: 1;
  margin-left: 5px;
  // margin-bottom: 4px;
}

>>>.collapse-title-down {
  flex: 1 0 90%;
  order: 1;
  margin-left: 5px;
  // margin-bottom: 4px;
}

.about-right {
  background: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.header {
  border-bottom: solid 1px rgb(237, 245, 255);
  display: flex;
  justify-content: space-around;
  padding: 20px;
}

.content {
  height: 600px;
  border-bottom: solid 1px rgb(237, 245, 255);
  overflow: scroll;
  overflow-x: hidden;
  padding: 20px;
}

.bottom {
  height: 360px;
  width: 920px;
}

>>>.el-collapse-item__wrap {
  border: none;
}

>>>.el-collapse-item__header {
  border: none;
  margin-left: 30px;
}

>>>.el-collapse,
>>>.el-collapse-item__content {
  border: none;
  padding-bottom: 0px;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);

  // width: 100%;
}

.white {
  background: white;
  z-index: 9999;
}

.headicon {
  margin-right: 10px;
}

>>>.quill-editor {
  height: 220px;
}

.find {
  // border-width: 1px;
  border-color: rgb(71, 145, 255);
  width: 218px;
  height: 10px;
  margin-left: 35px;
  margin-top: 25px;
  margin-right: 8px;
}

>>>.el-icon-arrow-up:before {
  content: url(../assets/images/arrow.png);
}

>>>.find .el-input__inner {
  border: solid 1px;
  border-radius: 40px;
  height: 35px;

  padding-left: 40px;
}

>>>.el-input__inner {
  // border: solid 1px;
  border-radius: 10px;
  // height: 35px;
  padding: 10px 10px 10px 20px;
}

.search {
  height: 34px;
  width: 85px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "HarmonyOS_Sans_SC";
  color: rgb(255, 255, 255);
  line-height: 3px;
  letter-spacing: 10px;
  border-radius: 20px;
}

.submit {
  height: 40px;
  width: 100px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "HarmonyOS_Sans_SC";
  color: rgb(255, 255, 255);
  line-height: 3px;
  margin-left: 776px;
  margin-top: 15px;
}

.findimg {
  margin-top: 9px;
  margin-left: 10px;
}

.dialog_icon {
  margin-right: 10px;
  margin-left: 4px;
  cursor: pointer;
}

.dialog_icon_total {
  display: flex;
  margin-left: 48px;
  margin-top: 20px;
}

>>>.bottom .el-textarea__inner {
  margin-left: 40px;
  width: 820px !important;
  height: 70px !important;
  margin-top: -10px;
  border-width: 1px;
  border-color: rgb(204, 227, 255);
  border-style: solid;
  border-radius: 10px;
  margin-bottom: 10px;
}

>>>.el-textarea__inner {
  resize: none;
  height: 60px;
}

::-webkit-scrollbar {
  // display: none;
  /* Chrome Safari */
}

.chatcontent {
  padding: 20px;
}

.chat-user-1 {
  display: flex;

  margin-top: 5px;
  font-size: 14px;
  font-family: "Adobe Heiti Std";
  color: rgb(51, 51, 51);
}

.chat-user-2 {
  margin-top: 5px;
  display: flex;
  flex-direction: row-reverse;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  line-height: 1.714;
  text-align: justifyLeft;
}

.chat-user-1-text {
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  max-width: 550px;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-all;
  padding: 10px 22px;
}

.chat-user-2-text {
  border-radius: 10px;
  background-color: rgb(71, 145, 255);
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 550px;
  padding: 10px 22px;
  word-wrap: break-word;
  word-break: break-all;
}

.chat-user-1-headicon {
  margin-right: 15px;
  margin-left: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  height: 50px;
  width: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.chat-user-2-headicon {
  margin-left: 15px;
  margin-right: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.agreebutton {
  // margin-right: -10px;
  width: 50px;
  line-height: 3px;
  text-align: left;
  padding: 12px 10px;
}

.refusebutton {
  width: 50px;
  line-height: 3px;
  text-align: left;
  padding: 12px 10px;
}

>>>.el-button+.el-button {
  margin: 0%;
}

.verify {
  color: red !important;
  margin-top: -40px;
  margin-left: 4px;
  margin-right: 57px;
  margin-bottom: -30px;
  display: none;
}

.el-icon-edit {
  margin-left: 5px;
  cursor: pointer;
}

>>>.el-form-item__label {
  margin-top: 15px;
}

>>>.el-form-item__label {
  line-height: 5px;
}

.emoimg {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 15px;
}

.emopackage {
  position: absolute;
  display: flex;
  word-wrap: break-word;
  width: 340px;
  max-height: 420px;
  padding: 5px;
  overflow: hidden;
  transform: translateY(-90px);
  margin-left: 50px;
  display: none;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  background-color: white;
}

.dialogimg {
  width: 60px;
  height: 60px;
}

.dialogpiture {
  width: 120px;
  height: 120px;
}

>>>.el-upload-list__item {
  display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}

>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.industry {
  margin-left: 20px;
}

.aboutpicture {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  margin-right: 0px;
}

.abouttype {
  font-size: 16px;
  margin-bottom: 20px;
  margin-left: 50px;
  cursor: pointer;
  position: relative;
}

.numcare {
  position: absolute;
  left: 40px;
  bottom: 45px;
  border-radius: 50%;
  line-height: 20px;
  background-color: #f00;
  font-size: 15px;
  text-align: center;
  width: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow {
  width: 6px;
  height: 10px;
  float: right;
  transform: translateY(-59px);
  margin-right: 40px;
}

.horn {
  width: 15px;
  height: 15px;
  align-items: center;
  margin-top: 4px;
  margin-left: 35px;
  cursor: pointer;
}

.marquee {
  display: flex;
  color: grey;
  font-size: 13px;
  justify-content: space-between;
}

li {
  border-radius: 15px;
  padding: -10px;
}

.marquees {
  padding: 8px 0;
  background-color: rgb(245, 249, 250);
}

.more {
  margin-right: 35px;
  cursor: pointer;
  z-index: 999;
}

.marqueemove {
  overflow: hidden;
  width: 480px;
  // white-space: nowrap;
  // animation: moveRight 8s linear infinite;
}

.text {
  text-align: initial;
  white-space: nowrap;
  animation: moveRight 16s ease-in-out infinite;
  overflow: hidden;
}

@keyframes moveRight {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-50%);
  }
}

.el-menu {
  margin-top: 0px;

  margin-left: 30px;
}

>>>.el-menu li {
  // margin-left: 30px;
  border-radius: 0px;
}

>>>.el-menu-demo el-menu--horizontal el-menu {
  border: none;
}

>>>.el-menu.el-menu--horizontal {
  border: none;
}

>>>.el-menu li {
  width: 75px;
  padding: 9px;
}

>>>.ql-toolbar.ql-snow {
  border: none;
  height: 0px !important;

  border-bottom: 1px solid #ccc;
}

>>>.el-menu-item.is-active {
  border-bottom: solid 1px #ccc;
}

.el-page-header {
  margin-left: 10px;
  margin-top: 10px;
}

>>>.el-page-header__left::after {
  display: none;
}

.time {
  text-align: right;
  font-size: 12px;
  color: #999;
}

.data {
  margin-top: 10px;
  margin-left: 35px;
}

>>>.select_industry .el-input__inner {
  width: 180px;
  margin-left: 5px;
}

>>>.select_region .el-input__inner {
  width: 180px;
  margin-left: 5px;
}

.findpart {
  margin-top: -22px;
  margin-right: 15px;
}

.dialogpiture {
  width: 60px;
  height: 60px;
}

.mycollect {
  color: blue;
}

.mycollectno {
  color: blue;
}

.el-tag {
  border-radius: 15px;
}

>>>.ql-toolbar.ql-snow+.ql-container.ql-snow {}

.emoji-mart[data-v-7bc71df8] {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 420px;
  color: #ffffff !important;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
}

.blue {
  color: blue;
}

// >>>.el-select .el-tag {
//   background-color: white !important;
//   color: #606266;
//   margin: 2px 0 2px 16px;
//   font-size: 16px;
// }

// >>>.el-tag.el-tag--info {
//   border-color: white
// }

// >>>.el-icon-close:before {
//   content: none
// }
// >>>.el-select .el-tag__close.el-icon-close {
//   background-color: white
// }
</style><style lang="scss">
.down-popover[x-placement^="bottom"] {
  margin-top: 0px;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 32px !important;
}

.option-item {
  line-height: 28px;
  margin-top: 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
    background: #f5f7fa;
  }
}

.nosearch {
  padding-top: 15px;
  color: grey;
  text-align: center;
  font-size: 12px;
}

.ql-snow .ql-editor img {
  width: 20px;
  height: 20px;
}

.ql-container.ql-snow {
  border: 1px solid #2c97e9;

  height: 150px;
  z-index: 9999;
}

.multchoice {
  font-size: 16px;
}

.image-container img {
  width: 20px;
  height: 20px;
}

.el-checkbox-group {
  margin-top: 20px;
  margin-bottom: 20px;
}

.chatname {
  font-size: 12px !important;

  margin-bottom: 10px;
}

.time {
  margin-left: 9px;
  color: #aaa;
}

.block {
  margin-bottom: 40px;

  .h3 {
    font-size: 15px;
    color: #333333;
    margin-bottom: 30px;
  }

  .pro-list {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;

    .pro-item {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 5px 16px;
      font-size: 14px;
      border-radius: 15px;
      color: #2c97e9;
      border: 1px solid #2c97e9;
      background-color: #fff;

      &.active {
        background-color: rgb(10, 108, 255);
        color: #fff;
      }
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue